import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useConfirmationAction } from '../../../../hooks/confirmation-action.hook';
import { KnownDeliveryDtoState, KnownDeliveryState } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useMutationMarkDeliveryRetrieved } from '../../deliveries-details.queries';
import { useWaitForUpdate } from '../../hooks/use-wait-for-update.hook';
import { Delivery } from '../../../models/delivery.model';
import { Colors } from '../../../../../ui/theme/colors';

export function MarkRetrievedModal({
  delivery,
  onAbort,
  onFailed,
  onSuccess
}: {
  delivery: Delivery;
  onAbort(): void;
  onFailed(): void;
  onSuccess(): void;
}) {
  const onSuccessHandler = useWaitForUpdate({
    maximumWaitTime: 1000 * 10,
    onFailed,
    onSuccess,
    predicate: () => delivery.state === KnownDeliveryState.Retrieved
  });

  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationMarkDeliveryRetrieved,
    mutationArgs: { deliveryID: delivery.id },
    onSuccess: onSuccessHandler
  });

  return (
    <ConfirmationModal
      title="Mark Retrieved?"
      content={makeModalContent(delivery.state)}
      onConfirm={onConfirm}
      onCancel={onAbort}
      actionButton={{
        label: 'Mark Retrieved',
        colorOverride: Colors.retrievedPurple
      }}
      cancelButton={{
        label: 'No'
      }}
      {...state}
    />
  );
}

function makeModalContent(status: string): string[] {
  const content = [
    `Marking the delivery Retrieved is for when you've removed the delivery and returned it to the sender.`
  ];

  if (assertIsIntermediateState(status)) {
    content[0] += ` We'll update the locker state to reflect that it is now empty and the recipient's collection code will no longer work.`;
    content.push(
      `If the delivery has been taken out of the locker and given to the recipient instead, mark it Collected.`
    );
  }

  content.push(`Are you sure?`);

  return content;
}
function assertIsIntermediateState(status: string) {
  return [
    KnownDeliveryDtoState.Delivered,
    KnownDeliveryDtoState.Overdue,
    KnownDeliveryDtoState.RetrievalRequired
  ].includes(status as KnownDeliveryDtoState);
}
